import { useEffect, useState } from "react";
import { connect } from "react-redux";
import ajaxServices from "../../../utils/ajaxServices";
import { useRouter } from "../../atoms/DependencyHelper";
import UpgradeComponent from "../upgradeModal/UpgradeModal";
import { maskMsisdn } from "../../../services/upgradeService";
import {
    link as AnalyticsLink,
    getUtagData as AnalyticsGetUtagData,
    getProfileData as AnalyticsGetProfileData,
    view as AnalyticsView
  } from "services/analyticsUtag";
import labels from "../../../config/labels";
import config from "../../../config/index";

const AffordabilityContainer = ({
    showModal, toggleModal, resultCode, profileData, userLoggedIn, upgradeResponse
}) => {
    const [displayData, setDisplayData] = useState({});
    const [selectedNumber, setSelectedNumber] = useState("");
    const router = useRouter();
    const env = config.env;
    const imagePrefix = config.envConfigs[env].imagePrefix;

    const getUtagViewData = () => {
        return AnalyticsGetUtagData(["visitor_customer_id",
            "visitor_login_status",
            "visitor_subscription_type",
            "page_site_section_lvl_1",
            "page_site_section_lvl_2",
            "page_site_section_lvl_3",
            "page_site_section_lvl_4",
            "visitor_msisdn_hash",
            "page_name",
            "page_channel",
            "page_master_tab",
            "upgrade_eligibility_status",
            "upgrade_ineligible_reason",
            "upgrade_eligible_date",
            "upgrade_customer_type",
        ])
    };

    const ctaRedirection = (route) => {
        const pageName = AnalyticsGetUtagData(["page_name"]).page_name;
        AnalyticsLink({
            page_tool_event: "o",
            page_tool_name: `${pageName}: show deals`,
            ...getUtagViewData()
        });
        router.push(route)
    }

    const handleNewSelect = ( selectedValue) => {
        setSelectedNumber(selectedValue);
    }

    useEffect(() => {
        async function fetchDisplayData() {
            let affordData = {};
            let dropdownData = [{
                num: upgradeResponse.msisdn,
          id: 1,
          label:  upgradeResponse.upgradeEligible ? `${maskMsisdn(upgradeResponse.msisdn)} (Upgradeable)` : `${maskMsisdn(upgradeResponse.msisdn)} (Not upgradeable)`,
          upgradeEligible: upgradeResponse.upgradeEligible
            }]
            setSelectedNumber(dropdownData[0].label);
            const responseData = await ajaxServices.httpGet(
                "drupalBaseUrl",
                "",
                "api",
                "upgradeResult",
                [resultCode]
            );
            if (responseData.length) {
                affordData = {
                    iconUrl: responseData[0]?.icon || "",
                    title: responseData[0]?.resultTitle || "",
                    analyticsTitle: responseData[0]?.analyticTitle || "",
                    description: responseData[0]?.resultHTML
                        ? responseData[0]?.resultHTML
                        : responseData[0]?.resultText || "",
                    primaryButtonText:
                    responseData[0]?.primaryEnabled === "Yes"
                            ? responseData[0]?.primaryCTAText
                            : null,
                    onClickHandlerPrimary:() => ctaRedirection(responseData[0]?.primaryCTAURL),
                    dropdown:true,
                    handleVal:handleNewSelect,
                    selectedDropdownValue: selectedNumber ? selectedNumber : dropdownData[0].label,
                    dropdownData:dropdownData,
                }
            } else {
                affordData = {
                    iconUrl: `${imagePrefix}/assets/images/icon-info.svg`,
                    title: labels.upgrade.lbl_afford_title,
                    description: labels.upgrade.lbl_afford_desc,
                    primaryButtonText: labels.upgrade.lbl_afford_btn,
                    onClickHandlerPrimary: ctaRedirection("/shopping/deals"),
                    dropdown:true,
                    handleVal:handleNewSelect,
                    selectedDropdownValue: selectedNumber ? selectedNumber : dropdownData[0].label,
                    dropdownData:dropdownData,
                }
            }
            setDisplayData(affordData);
        }
        fetchDisplayData();
    }, [])

    useEffect(() => {
        const userMetaData = AnalyticsGetProfileData(
            userLoggedIn,
            profileData
        );
        AnalyticsView({
            page_event: "view",
            page_name: displayData.analyticsTitle,
            page_channel: "shopping",
            page_master_tab: "personal",
            ...AnalyticsGetUtagData([
                "page_site_section_lvl_1",
                "page_site_section_lvl_2",
                "page_site_section_lvl_3",
                "page_site_section_lvl_4",
            ]),
            upgrade_eligibility_status: `${upgradeResponse?.upgradeEligible ? upgradeResponse?.upgradeEligible : false}`,
            upgrade_eligible_date: upgradeResponse?.upgradeDate || "",
            upgrade_ineligible_reason: (!upgradeResponse?.upgradeEligible) ? `${displayData.title}` : null,
            upgrade_customer_type: upgradeResponse ? null : upgradeResponse?.c3dCustomer ? "C3D" : upgradeResponse?.business ? "EBU" : "Legacy",
            ...userMetaData,
        });
    }, [displayData])

    const hideModal = () => {
        const pageName = AnalyticsGetUtagData(["page_name"]).page_name;
        AnalyticsLink({
            page_tool_event: "use",
            page_tool_name: `${pageName}: dismiss`,
            ...getUtagViewData()
        });
        toggleModal();
    }

    return (
        <UpgradeComponent
            showModal={showModal}
            displayData={displayData}
            toggleModal={hideModal}
        />
    )
}



const mapStateToProps = (state) => ({
    profileData: state.navDetails.profileData,
    userLoggedIn: state.navDetails.isUserLoggedIn,
    upgradeResponse: state.upgrade.upgradeResponse,
})
export default connect(mapStateToProps, {})(AffordabilityContainer);